lmApp
  .service('ManageSubscribersWindow', ['$rootScope', '$q', '$templateCache', '$compile', 'ValidatorService', 'SubscriberResource', 'ModalWindowService', 'ToastService',
    function ($rootScope, $q, $templateCache, $compile, ValidatorService, SubscriberResource, ModalWindowService, ToastService) {
      var service = {};

      service.Open = function (options) {
        var windowScope = $rootScope.$new();

        windowScope.loading = false;
        windowScope.fullscreen = false;
        windowScope.keyword = '';
        windowScope.filters = {};
        windowScope.offset = 0;
        windowScope.limit = 20;
        windowScope.isEnd = false;
        windowScope.isStart = windowScope.offset === 0;

        windowScope.searchResult = [];
        windowScope.title = options.title;
        windowScope.isSingle = options.type === 'single';
        windowScope.currentCollection = options.currentCollection || [];

        windowScope.$watch('filters', function (newValue, oldValue) {
          if (oldValue && !_.isEmpty(newValue)) {
            windowScope.applyFilters(newValue);
          }
        });

        windowScope.nextPage = function () {
          if (windowScope.isEnd) return;
          windowScope.offset += windowScope.limit;
          windowScope.isStart = windowScope.offset === 0;
          windowScope.applyFilters(windowScope.filters, true);
        };

        windowScope.prevPage = function () {
          if (windowScope.isStart) return;

          if (windowScope.offset >= windowScope.limit) {
            windowScope.offset -= windowScope.limit;
            windowScope.isStart = windowScope.offset === 0;
          } else {
            windowScope.offset = 0;
            windowScope.isStart = true;
          }
          windowScope.applyFilters(windowScope.filters, true);
        };

        windowScope.applyFilters = function (filters, is_force) {
          if (!is_force && (windowScope.loading || _.isEmpty(filters))) return;

          windowScope.isEnd = false;

          $rootScope.showLinearProgress('#mgmtWindowLoader');
          windowScope.loading = true;

          filters.keyword = _.trim(filters.keyword);

          var params = {};
          if (filters.keyword !== '') {
            windowScope.offset = 0;
            windowScope.limit = 20;
            params['username[in]'] = filters.keyword
          }
          params['$limit'] = windowScope.limit + 1;
          params['$offset'] = windowScope.offset;

          return SubscriberResource.get(params).$promise
            .then(function (result) {
              var collection = result.data;
              if (collection.length !== windowScope.limit + 1) {
                windowScope.isEnd = true;
              } else {
                collection.splice(windowScope.limit + 1, 1);
              }

              windowScope.searchResult = collection;
              $rootScope.hideLinearProgress('#mgmtWindowLoader');
              windowScope.loading = false;
              return collection;
            })
            .catch(function (reason) {
              $rootScope.hideLinearProgress('#mgmtWindowLoader');
              windowScope.loading = false;
            });
        };

        windowScope.manageSubscribers = {
          add: [],
          remove: [],
          single: {}
        };

        windowScope.close = function () {
          if (windowScope.loading) return;

          windowScope.fullscreenToogle(false);
          ModalWindowService.Close(windowScope.window, false);
        };

        windowScope.fullscreenToogle = function (state) {
          if (typeof state !== 'undefined') {
            windowScope.fullscreen = state;
          } else {
            windowScope.fullscreen = !windowScope.fullscreen;
          }

          ModalWindowService.Fullscreen(windowScope.window, state);
        };

        windowScope.addSubscriberTo = function (subscriber) {
         if (windowScope.isSingle) {
            windowScope.manageSubscribers.single = subscriber;

            windowScope.searchResult.forEach(function (subscriber) {
              subscriber._PrivateData.inCurrent = false;
            });

            subscriber._PrivateData.inCurrent = true;
          } else {
            subscriber._PrivateData.inCurrent = true;

            var inNew = false;
            windowScope.manageSubscribers.remove.forEach(function (item, index, collection) {
              if (item.id === subscriber.id) {
                collection.splice(index, 1);
                inNew = true;
              }
            });

            if (!inNew) windowScope.manageSubscribers.add.push(subscriber);
          }
        };

        windowScope.removeSubscriberFrom = function (subscriber) {
          if (windowScope.isSingle) {
            windowScope.manageSubscribers.single = {};

            windowScope.searchResult.forEach(function (subscriber) {
              subscriber._PrivateData.inCurrent = false;
            });
          } else {
            subscriber._PrivateData.inCurrent = false;

            var inNew = false;
            windowScope.manageSubscribers.add.forEach(function (item, index, collection) {
              if (item.id === subscriber.id) {
                collection.splice(index, 1);
                inNew = true;
              }
            });

            if (!inNew) windowScope.manageSubscribers.remove.push(subscriber);
          }
        };

        windowScope.manageSubscribersFor = function () {
          $rootScope.showLinearProgress('#mgmtWindowLoader');
          windowScope.loading = true;

          var allQ;
          if (windowScope.isSingle) {
            allQ = options.manageSubscribersFn(windowScope.manageSubscribers.single, options.obj);
          } else {
            allQ = options.manageSubscribersFn(windowScope.manageSubscribers.add, windowScope.manageSubscribers.remove, options.obj);
          }

          $q.all(allQ)
            .then(function () {
              $rootScope.hideLinearProgress('#mgmtWindowLoader');
              windowScope.loading = false;
              ToastService.Small({
                title: 'Subscribers successfully added/removed',
                color: 'green',
                icon: 'package-down'
              }, 1000 * 3);
              windowScope.close();
              $rootScope.$broadcast($rootScope.EVENTS.UPDATE_GROUP_COLLECTION);
            })
            .catch(function (reason) {
              ToastService.Small({
                title: 'Error happened. Try again',
                color: 'red',
                icon: 'package-down'
              }, 1000 * 3);
              $rootScope.debugInfo(reason);
              $rootScope.hideLinearProgress('#mgmtWindowLoader');
              windowScope.loading = false;
            });
        };


        windowScope.$watch('searchResult', function (newValue, oldValue) {
          windowScope.searchResult.forEach(function (subscriber) {
            if (!subscriber._PrivateData) subscriber._PrivateData = {};
            subscriber._PrivateData.inCurrent = _.includes(windowScope.currentCollection, subscriber.id);
            return subscriber;
          });
        });

        windowScope.selectAll = function () {
          if (!windowScope.isSelectedAll()) {
            windowScope.searchResult.forEach(function (subscriber) {
              windowScope.addSubscriberTo(subscriber);
            });
          } else {
            windowScope.searchResult.forEach(function (subscriber) {
              windowScope.removeSubscriberFrom(subscriber);
            });
          }
        };

        windowScope.isSelectedAll = function () {
          return windowScope.searchResult.filter(function (subscriber) {
              return subscriber._PrivateData.inCurrent;
            }).length === windowScope.searchResult.length;
        };

        windowScope._modalWindow_ = $templateCache.get('lm-manage-subscribers-window/lm-manage-window.tpl.html');
        windowScope._modalWindow_ = $compile(windowScope._modalWindow_)(windowScope);

        windowScope.window = ModalWindowService.Open({
          content: windowScope._modalWindow_,
          navigation: $compile($templateCache.get('lm-manage-subscribers-window/lm-manage-window-nav.tpl.html'))(windowScope),
          clear: true,
          keyboard: true,
          size: {
            s: 11,
            l: 10
          },
          onComplete: function () {
            windowScope.$destroy();
          }
        });

        windowScope.applyFilters({keyword: ''});
      };

      return service;
    }]);
